import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedInUserKeys, LoggedInUserService } from '../shared/service/logged-in-user.service';
import { HttpClient, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { CommonService } from '../shared/service/common.service';
import { firstValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthSessionService } from '../shared/service/auth-session.service';
import { expireCookieSession } from '../shared/utils/auth-session';

@Component({
    selector: 'app-redirect-handler',
    templateUrl: './redirect-handler.component.html',
    styleUrls: ['./redirect-handler.component.scss'],
    standalone: false
})
export class RedirectHandlerComponent {
  constructor(
    private route: ActivatedRoute,
    private _commonService :CommonService,
    private router: Router,
    private http: HttpClient,
    private _loggedInUserService: LoggedInUserService,
    private _toastService:ToastrService,
    private _authSessionService: AuthSessionService
  ) {}

  jsonDecodedData: any;
  loading:boolean = false;
  ngOnInit(): void {
    this.decodeAndNavigate();
  }

 async decodeAndNavigate(): Promise<void> {
    this.route.queryParams.subscribe(async params => {
      const base64Data = params['data'];
      if (base64Data) {
        try {
          console.log('try block');
          // Decode the Base64 string and convert to JSON
          this.jsonDecodedData =JSON.parse(atob(base64Data));
          this.jsonDecodedData.userRole = "CANDIDATE";
          if(this.jsonDecodedData?.driveId){
            sessionStorage.setItem('inviteDriveId', this.jsonDecodedData.driveId);
          }
           console.log('jsonDecodedData data stored in local storage ');
          // The link carries its own token. Drop any earlier cookie session so the token is
          // kept (and sent as Bearer) for the first call, then trade it for a cookie.
          expireCookieSession();
          this._loggedInUserService.setLoggedInUser(LoggedInUserKeys.LOGGED_IN_USER,this.jsonDecodedData);
          const isSuccess = await this.setBasicDetails();
          await this._authSessionService.upgradeLegacySession();
          let userData = this._loggedInUserService.getLoggedInUser(LoggedInUserKeys.LOGGED_IN_USER);
          if (isSuccess) {
            if(this.jsonDecodedData?.isLogin && userData){
              console.log('handleNavigation called');
              this.handleNavigation(userData);
            }else{
              console.log('routed to provided url');
              // this.router.navigate([this.jsonDecodedData.route]);
              this.router.navigate([this._commonService.Navigations.DASHBOARD+
                "?webUser=true"
               ]); 
            }
            this._toastService.success('Logged in successfully.');
          }else{
            console.log('Api failed or not 200');
              this.router.navigate(['/']); // Fallback
          }
        } catch (error) {
          console.error('catch block', error);
          this.router.navigate(['/']); // Fallback
        }
      } else {
        console.log(' outer else block');
        this.router.navigate(['/']); // Fallback
      }
    });
  }

  async setBasicDetails():Promise<boolean>{
    this.loading = true;
    try {
      console.log('basic detail api calling');
       const response = await firstValueFrom( this._commonService.getBasicDetails());
        if (response.statusCode === HttpStatusCode.Ok && response.data) {
          this.loading = false;
          console.log(response.data,'response.data');
          this._loggedInUserService.setLoggedInUser(LoggedInUserKeys.LOGGED_IN_USER,{...this.jsonDecodedData,...response.data});
          console.log('basic details data stored in local storage ');
          return true; 
        }else{
          this.loading = false;
          return false;
        }
    } 
    catch (error) {
      this.loading = false;
      console.error(error);
      return false;
    }
    
  }

  handleNavigation(userData: any) {
    const {
      isFirstTimeLogin,
      isProfileDetailsUpdated,
      isProfileDetailsSkipped,
      hasRegisteredDrives,
    } = userData;

    const profileCompleted = isProfileDetailsUpdated;

    if (isFirstTimeLogin) {
      this.router.navigate([
        this._commonService.Navigations.NEW_PROFILE_DETAILS,
      ]);
      // this.router.navigate([this.service.Navigations.BASIC_DETAILS]);
    } else if (!profileCompleted) {
      this.router.navigate([
        this._commonService.Navigations.NEW_PROFILE_DETAILS,
      ]);
    } else if (hasRegisteredDrives) {
      this.router.navigate([
        this._commonService.Navigations.DASHBOARD_ASSESSMENT,
      ]);
    } else {
      this.router.navigate([this._commonService.Navigations.DASHBOARD+
        "?webUser=true"
      ]);
    }
  }
}

